import React from 'react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiNotebook } from 'react-icons/pi';
import { Job, ReportTemplate } from '@ais-ui/websockets';

interface ShowLastReportButtonProps {
  report?: Job;
  reportTemplate: ReportTemplate;
  setSelectedReport: React.Dispatch<React.SetStateAction<Job | null>>;
  setSelectedReportTemplate: React.Dispatch<
    React.SetStateAction<ReportTemplate | null>
  >;
}

export const ShowLastReportButton = ({
  report,
  reportTemplate,
  setSelectedReport,
  setSelectedReportTemplate,
}: ShowLastReportButtonProps) => {
  const onSelect = () => {
    if (report) {
      setSelectedReport(report);
      setSelectedReportTemplate(reportTemplate);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          id={`showLastReportButton${reportTemplate.tplName}`}
          size="smIcon"
          variant="ghost"
          onClick={onSelect}
          disabled={!report}
        >
          <PiNotebook className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Show last report</TooltipContent>
    </Tooltip>
  );
};
